/**
 * `modules/gsap/gsap.js`
 * - GSAPの動的import&プラグインを一括登録
 *
 * 使用方法:
 * - import {gsap} from "./modules/gsap/gsap.js";
 * - 動的importにしているので、node_modules内ではなく↑を読み込んで使う。
 */


import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin.js";

gsap.registerPlugin(ScrollToPlugin);


export {gsap, ScrollToPlugin};
